/* eslint-disable no-undef */
import Vue from "vue"
import ApiUrl from "../apiurl"

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async getknowTradPa({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.knowledge.knowTradPa, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		
		async getknowTrademark({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.knowledge.knowTrademark, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getknowTradeRz({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.knowledge.knowTradeRz, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
        async getknowTradeCert({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.knowledge.knowTradeCert, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		async getknowTradeStd({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.knowledge.knowTradeStd, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		}
	}
}
